import React from 'react';

// Importing all sections used in the homepage
import { Home, About, Counter, Testimonials, Blogs, Services, NewsletterSection, Features, Team, Banner, WhyChooseUs, Process, Pricing, GetQuote, Clients, PortfolioSection } from '../../sections';



const HomePage = () => {

  return (
    <div className='homepage'>
      <Home /> {/* Home Section */}
      <Features /> {/* Features Section */}
      <About /> {/* About Section */}
      <Counter /> {/* Counter Section */}
      <Services /> {/* Services Slider */}
      <WhyChooseUs /> {/* Why Choose Us section */}
      <Process /> {/* Process section */}
      <Banner /> {/* Banner Section */}
      <PortfolioSection /> {/* Portfolio Section */}
      <Testimonials /> {/* Testimonials Slider */}
      <Team /> {/* Team section */}
      <GetQuote /> {/* Get Quote section */}
      <Pricing /> {/* Pricing section */}
      <NewsletterSection /> {/* Newsletter subscription Section */}
      <Blogs /> {/* Latest blog posts */}
      <Clients /> {/* Clients Slider */}
    </div>
  )

}

export default HomePage;